__turbopack_context__.v({
  "main": "HowItWorksBtn-module-scss-module__HVBuza__main",
  "responsive": "HowItWorksBtn-module-scss-module__HVBuza__responsive",
});
